{
  "en": {
    "toast": {
      "action": {
        "failed": "Action failed",
        "impersonate_unauthorized": "This action is not allowed when impersonating a customer.",
        "succeeded": "Action succeeded",
        "unprocessable": "Something went wrong, you might want to refresh the page. If the problem persists, please reach out. \nERROR: {error}"
      },
      "create": {
        "failed": "Failed to create {itemName}",
        "succeeded": "{itemName} created"
      },
      "delete": {
        "failed": "Failed to delete {itemName}",
        "succeeded": "{itemName} has been deleted",
        "succeeded_default": "Deletion succeeded"
      },
      "update": {
        "failed": "Failed to update {itemName}",
        "succeeded": "{itemName} has been updated",
        "successfully_saved": "Successfully saved"
      },
      "upload": {
        "failed": "Upload failed",
        "succeeded": "Upload succeeded"
      },
      "upload_document": {
        "extension_invalid": "The document \"{document_name}\" does not have a valid extension."
      },
      "upload_image": {
        "file_too_big": "File too big: maximum file size is 5MB"
      },
      "warning": {
        "multipleFiles": "This export contains multiple zip files. Your browser may block multiple downloads. Please contact Ziggu support if you have only 1 zip file downloaded."
      }
    }
  }
}